import React from 'react';
import MultiResolutionImage from './MultiResolutionImage';

export default ({ prefix, html, image, orientation }) => {
  const blocks = orientation === `left` ? [`text`, `image`] : [`image`, `text`];

  return (
    <section className="section is-text-image-block">
      <div className="container">
        <div className="columns is-mobile is-multiline">
          {blocks.map(blockType => {
            return (
              <div
                key={`${prefix}-${blockType}`}
                className={`column is-12-mobile is-6-tablet ${
                  blockType === `text`
                    ? 'is-order-2-mobile'
                    : 'is-order-1-mobile'
                }`}
              >
                {blockType === `text` ? (
                  <div
                    className={`content is-orientation-${orientation}`}
                    dangerouslySetInnerHTML={{ __html: html }}
                  />
                ) : (
                  <div className="is-full-width-mobile">
                    <MultiResolutionImage image={image} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/TextImageBlock.js